/**
 * Created by JaneCC on 2018-04-12 .
 */
import {
    isObj
} from '../utils';
import storage from '../helper/storage';

export default {
    pin(state, change) {
        state.pin = change;
    },
    userInfo(state, change) {
        state.userInfo = change;
    },
    token(state, change) {
        state.token = change;
    },
    hasApproveManage(state, change) {
        state.hasApproveManage = change;
    },
    companyId(state, change) {
        state.companyId = change;
    },
    win(state, change) {
        state.win = change;
        storage.set('win', change);
    },
    updateTerminal(state, change) {
        state.terminal = change;
    },
    updateHost(state, change) {
        state.host = change;
        // storage.set('host', change);
    },
    updateCode(state, change) {
        state.companyCode = change;
        storage.set('companyCode', change);
    },
    updateAuthSign(state, change) {
        state.authSign = change || {};
        storage.set('authSign', state.authSign);
    },
    updateSignIn(state, change) {
        // state.userAgentVO = change.usrAgentVO || {};
        let userInfo = change.profileVo || {};
        userInfo.score = change.score || 0;
        state.userInfo = userInfo;
        state.companyInfo = change.companyInfo || {};
        state.credential = change.credential || {};
        state.token = (change.credential && change.credential.token) || '';
        storage.set('loginInfo', change);
        // storage.set('userAgentVO', state.userAgentVO);
        // storage.set('userInfo', state.profileVo);
        // storage.set('companyInfo', state.companyInfo);
        // storage.set('credential', state.credential);
        storage.set('token', state.token);
    },
    updateCompanyInfo(state, change) {
        state.companyInfo = change || {};
        storage.set('companyInfo', state.companyInfo);
    },
    updateWxUserInfo(state, change) {
        state.wxUserInfo = change || {};
        storage.set('wxUserInfo', state.wxUserInfo);
    },
    updateUserInfo(state, change) {
        state.userInfo = change || {};
        storage.set('userInfo', state.userInfo);
    },
    updateToken(state, change) {
        state.token = change || '';
        storage.set('token', state.token);
    },
    updateTabbar(state, change) {
        state.tabbar = change || false;
        // storage.set('tabbar', state.tabbar);
    },
    updateArea(state, change) {
        state.area = change || {};
    },
    updateCart(state, change) {
        state.cart = change || [];
        storage.set('cart', state.cart);
    },
    updateShare(state, change) {
        state.share = change || false;
    },
    updateShareInfo(state, change) {
        state.shareInfo = change || false;
    },
    updateOpenId(state, change) {
        state.openId = change || '';
        storage.set('openId', state.openId);
    },
    updateOrderPackage(state, change) {
        state.orderPackage = change || [];
        storage.set('orderPackage', change);
    },
    updateHeadDOM(state, change) {
        let A = {};
        if (!isObj(change)) {
            A = {
                title: change,
                description: change,
                keywords: change
            };
        } else {
            A = change;
        }
        state.headDOM = A;
        // if (wx && wx.setNavigationBarTitle) {
        //     wx.setNavigationBarTitle({
        //         title: A.title
        //     });
        // }
    }

};
